
import { defineComponent } from 'vue'
import VueElementLoading from 'vue-element-loading'
import axios from 'axios'
import {
  RoomSearchParams,
  RoomSearchResult,
  RoomSearchResultItem,
} from '../room'

export type DataType = {
  params: RoomSearchParams
  rooms: RoomSearchResultItem[]
  loading: boolean
  searched: boolean
}

export default defineComponent({
  name: 'PzldjdxRoomSearch',
  components: {
    VueElementLoading,
  },
  data(): DataType {
    return {
      params: new RoomSearchParams({}),
      rooms: [],
      loading: false,
      searched: false,
    }
  },
  mounted() {
    const locationSearch = window.location.search
    if (locationSearch === '') {
      return
    }

    this.params = RoomSearchParams.fromURLSearchParams(
      new URLSearchParams(locationSearch)
    )
    this.loading = true
    const url = process.env.VUE_APP_API_BASE_URL
    axios
      .get(url + '/rooms', {
        params: this.params.toQueryParams(),
      })
      .then((res) => {
        let list = RoomSearchResult.fromApiData(res.data).rooms
        // 都道府県コード順並べ替える
        list.sort((a, b) => {
          return parseInt(a.prefectureCode, 10) - parseInt(b.prefectureCode, 10)
        })
        this.rooms = list
        this.loading = false
        this.searched = true
      })
  },
  methods: {
    postalCode(s: string) {
      return s.length === 7 ? s.substr(0, 3) + '-' + s.substr(3) : ''
    },
  },
})
